import axios from "axios";
import { buildApiUrl, getApiBaseUrl } from "../config/api";

export async function fetchTeacherHrSummary(teacherId) {
    const { data } = await axios.get(buildApiUrl(`/TeacherHr/${teacherId}/summary`));
    return data;
}

export async function fetchTeacherManagementOverview(schoolId) {
    const { data } = await axios.get(buildApiUrl(`/TeacherManagement/${schoolId}/overview`));
    return data;
}

export async function verifyTscNumber(teacherId, status) {
    const { data } = await axios.put(buildApiUrl(`/TeacherHr/${teacherId}/tsc-verify`), { status });
    return data;
}

export async function createQualification(teacherId, payload) {
    const { data } = await axios.post(buildApiUrl(`/TeacherHr/${teacherId}/qualifications`), payload);
    return data;
}

export async function uploadQualificationDocument(teacherId, schoolId, file) {
    const form = new FormData();
    form.append("file", file);
    form.append("schoolId", schoolId);
    const { data } = await axios.post(buildApiUrl(`/TeacherHr/${teacherId}/qualifications/upload`), form);
    return data;
}

export async function verifyQualification(id, { status, verifiedById }) {
    const { data } = await axios.put(buildApiUrl(`/TeacherQualification/${id}/verify`), { status, verifiedById });
    return data;
}

export async function deleteQualification(id) {
    await axios.delete(buildApiUrl(`/TeacherQualification/${id}`));
}

export async function createDeployment(teacherId, payload) {
    const { data } = await axios.post(buildApiUrl(`/TeacherHr/${teacherId}/deployments`), payload);
    return data;
}

export async function deleteDeployment(id) {
    await axios.delete(buildApiUrl(`/TeacherDeployment/${id}`));
}

export async function createCpdRecord(teacherId, payload) {
    const { data } = await axios.post(buildApiUrl(`/TeacherHr/${teacherId}/cpd`), payload);
    return data;
}

export async function deleteCpdRecord(id) {
    await axios.delete(buildApiUrl(`/TeacherCpd/${id}`));
}

export async function createAppraisal(teacherId, payload) {
    const { data } = await axios.post(buildApiUrl(`/TeacherHr/${teacherId}/appraisals`), payload);
    return data;
}

export async function updateAppraisal(id, payload) {
    const { data } = await axios.put(buildApiUrl(`/TeacherAppraisal/${id}`), payload);
    return data;
}

export async function createPayrollItem(teacherId, payload) {
    const { data } = await axios.post(buildApiUrl(`/TeacherHr/${teacherId}/payroll-items`), payload);
    return data;
}

export async function deletePayrollItem(id) {
    await axios.delete(buildApiUrl(`/TeacherPayrollItem/${id}`));
}

export async function generatePayslip(teacherId, period) {
    const { data } = await axios.post(buildApiUrl(`/TeacherHr/${teacherId}/payslip`), { period });
    return data;
}

export async function downloadPayslipPdf(payslipId) {
    const response = await axios.get(`${getApiBaseUrl()}/TeacherPayslip/${payslipId}/pdf`, {
        responseType: "blob",
    });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `payslip-${payslipId}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
